/* NutriGreen — shared reveal-on-scroll.
   Guarded so it never double-initialises, and re-scans when Dawn
   loads/reloads sections in the theme editor. Rail carousel JS is
   scoped inside the nutri-rail section itself. */
(function () {
  if (window.__nutriRevealInit) return;
  window.__nutriRevealInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var observer = null;
  if (!reduce && 'IntersectionObserver' in window) {
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
  }

  function reveal(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var els = scope.querySelectorAll('.nutri-reveal:not(.is-in)');
    els.forEach(function (el, i) {
      if (!observer) { el.classList.add('is-in'); return; }
      // stagger siblings in groups of 4, matching the prototype
      el.style.transitionDelay = (i % 4 * 60) + 'ms';
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { reveal(document); });
  } else {
    reveal(document);
  }

  // Theme editor: re-scan freshly injected sections.
  document.addEventListener('shopify:section:load', function (e) {
    reveal(e.target);
  });
})();
